import loadable from "@loadable/component";

export const Sections = {
	FullWidthSection: loadable(() => import(`./FullWidthSection`)),
};

export default Sections;
